import { combineReducers } from 'redux'
import language from './reducer-language'
import parameters from './reducer-parameters'

const root = combineReducers({
    language,
    parameters
  })
  
  export default root